<template>
  <div class="login">
    <div
      style="
      display:none;
        width: 800px;
        background-color: white;
        margin: auto;
        padding: 18px;
        margin-top: 10px;
      "
    >
      Bonjour,<br /><br />

      Une fuite de données s’est produite chez les opérateurs Tiers Payant
      VIAMEDIS et ALMERYS avec qui nous travaillons.<br />

      Cette brèche de sécurité ne concerne pas directement CPMS mais par mesure
      de sécurité pour les données de vos clients, nous bloquons volontairement
      et provisoirement sur nos espaces Assurés, les possibilités de
      modification des mots de passe ou de création de compte sur l'espace
      assuré.<br />

      Nous vous tiendrons informés de l'évolution de la situation.<br />

      Dans cette attente, nous restons à votre entière disposition pour tout
      renseignement complémentaire.<br />

      Bien cordialement
    </div>

    <div class="login_main">
      <div class="login_design">
        <div class="login_logo">
          <img alt="Cpms logo" src="../assets/cpms_logo.png" />
        </div>

        <div style="margin: 70px 0 300px"></div>

        <span class="design_e">Espace</span>
        <br />
        <span class="design_c">COURTIER</span>
        <div class="login_bg">
          <img alt="Cpms logo" src="../assets/login-background.jpg" />
        </div>
      </div>
      <div class="login_form">
        <div class="login_title">
          {{ loginTitle }}
        </div>

        <div style="margin-top: 100px">
          <!-- Create -->
          <CreateBroker v-if="form === 'createBroker'" :errorData="errorData" />
          <!-- Login -->
          <Login v-if="form === 'login'" :errorData="errorData" />
          <!-- Lost -->
          <Lost v-if="form === 'lost'" :errorData="errorData" />
          <!-- create password -->
          <CreatePassword
            v-if="form === 'createPassword'"
            :errorData="errorData"
          />
        </div>

        <div class="login_message">
          <div v-if="errorData.show">
            <div
              style="
                color: darkred;
                box-shadow: 0 0 3px 0 #ccc;
                padding: 10px;
                border-radius: 10px;
              "
              v-html="errorData.message"
            ></div>
            <div
              v-if="errorData.is_courtier"
              style="text-align: right; padding-top: 10px"
            >
              <a-button
                @click="form = 'lost'"
                type="primary"
                size="small"
                danger
              >
                Réinitialiser
              </a-button>
            </div>
          </div>
        </div>

        <div v-show="form != 'createPassword'" class="create_lost">
          <a-button
            type="primary"
            shape="round"
            size="small"
            ghost
            v-if="showButton('login')"
            @click="form = 'login'"
          >
            Connexion
          </a-button>

          <a-button
            type="primary"
            shape="round"
            size="small"
            ghost
            v-if="showButton('createBroker')"
            @click="form = 'createBroker'"
          >
            Créer un compte
          </a-button>

          <a-button
            type="primary"
            shape="round"
            size="small"
            ghost
            v-if="showButton('lost')"
            @click="form = 'lost'"
          >
            Compte oublié
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateBroker from "../components/auth/store.vue";
import Login from "../components/auth/Login.vue";
import Lost from "../components/auth/Lost.vue";
import CreatePassword from "../components/auth/CreatePassword.vue";

export default {
  name: "login",
  components: { CreateBroker, Login, Lost, CreatePassword },
  data: () => {
    return {
      form: "login",
      errorData: {
        message: "",
        is_courtier: false,
        show: false,
      },
    };
  },
  watch: {
    form(f) {
      this.initError();
    },
  },
  methods: {
    showButton(but) {
      return this.form == but ? false : true;
    },
    initError() {
      this.errorData = {
        message: "",
        is_courtier: false,
        show: false,
      };
    },
  },
  computed: {
    loginTitle() {
      if (this.form == "login") return "Connexion";
      if (this.form == "createBroker") return "Créer un compte";
      if (this.form == "lost") return "Compte oublié";
      if (this.form == "createPassword") return "Créer un mot de passe";
    },
  },
  mounted() {
    if (this.$route.name === "createPassword") {
      this.form = "createPassword";
    }
  },
};
</script>

<style scoped>
.login_main {
  width: 800px;
  height: 600px;
  margin: 50px auto;
  border-radius: 50px;
}
.login_design,
.login_form {
  width: 50%;
  height: 600px;
  display: inline-block;
  vertical-align: top;
}
.login_design {
  /* background-color: rgba(0, 0, 0, 0.72); */
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  text-align: right;
  padding: 0 40px;
  overflow: hidden;
  position: relative;
}
.login_bg {
  position: absolute;
  top: 0;
  left: -476px;
  z-index: -1;
}
.login_bg img {
  width: 1068px;
  opacity: 0.5;
}
.login_logo {
  margin: 100px 0 0 80px;
  background-color: white;
  width: 290px;
  padding-right: 30px;
}
.login_logo img {
  width: 290px;
}
span.design_e {
  color: black;
  font-size: 30px;
}
span.design_c {
  color: black;
  font-size: 40px;
  font-weight: bolder;
}
.login_form {
  background-color: #fff;
  padding: 60px 40px 0 40px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  position: relative;
}
.login_message {
  height: 140px;
  margin-top: 20px;
}
.login_form .ui.form {
  height: 206px;
}
.create_lost {
  position: absolute;
  bottom: 20px;
  width: 330px;
  display: flex;
  justify-content: space-evenly;
}
.login_title {
  position: absolute;
  font-size: 20px;
  color: grey;
  margin-top: -40px;
}
</style>
